import { render, staticRenderFns } from "./intents.vue?vue&type=template&id=71ae37a2&scoped=true&"
import script from "./intents.vue?vue&type=script&lang=js&"
export * from "./intents.vue?vue&type=script&lang=js&"
import style0 from "./intents.vue?vue&type=style&index=0&id=71ae37a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae37a2",
  null
  
)

export default component.exports